module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Selecione uma variação para vincular ao anúncio",
      "columns": 12,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sku),
      expression: "sku"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sku = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeVariation]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.product.variations), function(variation) {
    return _c('option', {
      key: variation,
      domProps: {
        "value": variation.sku
      }
    }, [_vm._v(_vm._s(_vm.variationTitle(variation)))])
  })], 2)])], 1), _vm._v(" "), (_vm.productCatalog) ? _c('panel', {
    staticClass: "blue-panel",
    attrs: {
      "title": "Produto vínculado"
    }
  }, [_c('panel', [_c('div', {
    staticClass: "product-catalog"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.productCatalog.pictures[0].url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.productCatalog.name) + "\n        ")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.variation) ? _c('variation-attributes', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "productId": _vm.product.productId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sku !== null) ? _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])]) : _vm._e(), _vm._v(" "), (_vm.variation) ? _c('general-attributes', {
    attrs: {
      "product": _vm.variation,
      "attributes": _vm.category.variations_attributes,
      "typeCheckout": _vm.typeCheckout
    }
  }) : _vm._e(), _vm._v(" "), (_vm.variation) ? _c('image-variation', {
    attrs: {
      "variation": _vm.variation
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-810763e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/variation/Single.vue
// module id = 3342
// module chunks = 0